// ABOUTME: React Query hooks for the W4 analysis panel (readiness + run mutations)

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { analysisApi } from '@/api/analysis'

export const useReadiness = () => {
  return useQuery({
    queryKey: ['hypothesis-readiness'],
    queryFn: analysisApi.getReadiness,
    staleTime: 60 * 1000,
  })
}

export const useRunAnalysis = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (hypothesisIds: string[]) => analysisApi.analyze(hypothesisIds),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['jobs'] }),
  })
}
